import {type_src_purchaser, type_src_supplier} from "@common/constact";
import {getCookie, getLoginUser} from "../../../../common/utils";

export function getState() {
  return window._vm.$store.state.index;
}

export function getState2() {
  return this.$store.state.index;
}

/*
* @desc 项目初始化
；流程
1.记录projectId
2.记录 currentLoginUser
3.记录 活动的名称
4.ajax获取所有的 栏目id
*/
export function action_init_flow() {
  setTimeout(() => {
    return window._vm.$store.dispatch("index/action_init_flow");
  }, 200)

}

export function getUserName() {
  var user = getState().user;
  var lang = sessionStorage.getItem("lang") || "zh";
  if (user.user2src == type_src_supplier) {
    var name = user.company || user.contact;
    var nameEn = user.companyEn || user.contactEn;
    return lang == "zh" ? name : nameEn;
  } else {
    var name = user.contact || user.company;
    var nameEn = user.contactEn || user.companyEn;
    return lang == "zh" ? name : nameEn;
  }
}

export function show_visibleLogin() {
  window._vm.$store.commit("index/show_visibleLogin");
}

export function close_visibleLogin() {
  window._vm.$store.commit("index/close_visibleLogin");
}

export function action_getLiveListAndVideoList() {
  return window._vm.$store.dispatch("index/action_getLiveListAndVideoList");
}

export function action_initFriendLink() {
  return window._vm.$store.dispatch("index/initFriendLink");
}

export function action_get_web_columnsList() {
  return window._vm.$store.dispatch("index/action_get_web_columnsList");
}

export function commit_recommendedPopupShow(recommendedPopupShow) {
  return window._vm.$store.commit("index/set_recommendedPopupShow", recommendedPopupShow);
}

export function commit_commitLiveShow(commitLiveShow) {
  return window._vm.$store.commit("index/set_commitmentLiveShow", commitLiveShow)
}

export function commit_exhibitsListPageNum(pageNum) {
  return window._vm.$store.commit("index/set_exhibitsListPageNum", pageNum)
}

export function get_recommendedPopupShow() {
  //存在就说明已经 第一次操作过了就不弹出框
  if (!getLoginUser().id) { //没有登陆 不要弹出框
    return false
  }
  var a = getCookie('set_recommendedPopupShow')
  console.log("推荐弹出框参数 .set_recommendedPopupShow ", a)
  if (a) {
    return false
  }
  return this.$store.state.index.recommendedPopupShow;
}


export function get_commitLiveShow() {
  if(!getLoginUser().id) {
    return false
  }

  // 刷新不显示
  var commitBook = getCookie('set_commitLiveShow')
  if(commitBook) {
    return false
  }
  return this.$store.state.index.commitLiveShow;
}

export function get_exhibitsListPageNum() {
  return this.$store.state.index.exhibitsListPageNum
}


// WEBPACK FOOTER //
// ./src/match/pages/index/store/stateUtil.js